import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=5b281a53&scoped=true&"
import script from "./Refund.vue?vue&type=script&lang=js&"
export * from "./Refund.vue?vue&type=script&lang=js&"
import style0 from "./Refund.vue?vue&type=style&index=0&id=5b281a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b281a53",
  null
  
)

export default component.exports